import { useTranslation } from 'react-i18next';

import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';
import { Popup } from '@/components/common/Popup';
import TargetAttributesPanel from './TargetAttributesPanel';

export default function TargetAttributesPopup({ closePopup }: { closePopup: () => Promise<void> }) {
  const { t } = useTranslation();

  const popupTitle = t('mainMenu.messages');
  const header = undefined;
  const body = (
    <div>
      <TargetAttributesPanel />
    </div>
  );
  const footer = undefined;

  if (isPhoneOrHighScreen()) {
    return (
      <Popup
        popupTitle={popupTitle}
        header={header}
        body={body}
        footer={footer}
        closePopup={closePopup}
        isFullScr={true}
        showCloseButton={false}
        leftText={true}
      />
    );
  }

  return (
    <>
      {header}
      {body}
    </>
  );
}
